import * as React from "react";
import { Template, FormData } from "../../types/Templates";

interface TemplateQuestionsProps {
  template: Template;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  formData: FormData;
}

const TemplateQuestions = ({
  template,
  setFormData,
  formData,
}: TemplateQuestionsProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const cleanedInput = e.target.value
      .trim()
      .replace(/\s+/g, " ")
      .toUpperCase();
    setFormData((prev) => ({
      ...prev,
      [`answer${index + 1}`]: { value: cleanedInput },
    }));
  };

  return (
    <div className="w-full pr-4">
      <h1 className="text-2xl font-semibold mb-4">
        Fill the Form for Template: {template.title}
      </h1>

      {template?.questions?.map((questionObj, index) => (
        <div key={index} className="mb-4">
          <label className="block text-gray-700">{questionObj.question}</label>
          <input
            type="text"
            value={formData[`answer${index + 1}`]?.value || ""}
            onChange={(e) => handleChange(e, index)}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </div>
      ))}
    </div>
  );
};

export default TemplateQuestions;
